var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("StoreHeader"),
      _c(
        "v-row",
        { staticClass: "ma-0 pa-0" },
        [
          _c("LeftStoreDetailNav"),
          _c(
            "v-col",
            { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "pa-0",
                  attrs: { id: "main_content_maxwidthset", cols: "12" },
                },
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-5 pt-10" },
                    [
                      _c(
                        "v-col",
                        { staticClass: "ma-0 pa-0" },
                        [
                          _vm.fetchLoading == false
                            ? _c(
                                "v-row",
                                {
                                  staticClass: "ma-0 pa-0",
                                  attrs: { align: "center" },
                                },
                                [
                                  _vm.cameraList.length > 0
                                    ? _vm._l(
                                        _vm.cameraList,
                                        function (item, index) {
                                          return _c(
                                            "v-col",
                                            {
                                              key: index,
                                              staticClass: "ma-0 pa-2",
                                              attrs: {
                                                id: "camera_cctv_box",
                                                cols: "4",
                                              },
                                            },
                                            [
                                              _c("ThumbnailListItem", {
                                                attrs: {
                                                  item: item,
                                                  index: index,
                                                  imgLoaders: _vm.imgLoaders,
                                                  streamingUrlLoading:
                                                    _vm.fetchLoading,
                                                },
                                                on: { onLoad: _vm.onLoadFunc },
                                              }),
                                            ],
                                            1
                                          )
                                        }
                                      )
                                    : [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-15",
                                            attrs: { cols: "12" },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(_vm.t("noCamera")) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                ],
                                2
                              )
                            : [
                                _c("ImageSkeleton", {
                                  attrs: {
                                    loaderCount: 9,
                                    width: "100%",
                                    height: "208px",
                                  },
                                }),
                              ],
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }